import { Component, Inject, OnInit } from '@angular/core';
import { SipService } from '../services/sip.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EveCall } from '../models/eve-call';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-dtmf-dialog',
  templateUrl: './dtmf-dialog.component.html',
  styleUrls: ['./dtmf-dialog.component.css']
})
export class DtmfDialogComponent {

  digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { call: EveCall },
    public dialogRef: MatDialogRef<DtmfDialogComponent>,
    private snack: MatSnackBar
  ) {}

 
  async sendDTMF(digit: string) {
    try {
      console.log(`🔢 Sending DTMF: ${digit}`);
      // Call sendDTMF on the active EveCall instance
      await this.data.call.sendDTMF(digit);
    } catch (error) {
      const errorMessage = "Failed to send DTMF: " + (error instanceof Error ? error.message : 'Unknown error');
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
